import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getApprovalListAsync } from '../ApprovalStore/approvalSlice';
import { Box } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import { schoolKycListColumn } from './column';
import useToast from '../../../hooks/useToast';
import { storeSchoolKycApiStatus } from './UserKycApproveStore/userKycApproveSlice';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';

function SchoolKycApprove() {
  const { ErrorToast } = useToast();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('pending');
  const [schoolKycUserId, setSchoolKycUserId] = useState('');

  const STATUS_OPTION = [
    { label: 'Pending', value: 'pending' },
    { label: 'Approve', value: 'approved' },
    { label: 'Rejected', value: 'rejected' },
  ];

  const { schoolKycList, schoolKycCount } = useSelector(
    ({ approvalReducer }) => {
      return {
        schoolKycList: approvalReducer.schoolKycList,
        schoolKycCount: approvalReducer.schoolKycCount,
      };
    }
  );

  useEffect(() => {
    dispatch(
      getApprovalListAsync({
        params: {
          entityType: 'kyc',
          approvalType: 'school-kyc-status',
          limit: 10,
          page: 1,
          statuses: ['pending'],
          latestFirst: true,
        },
        type: 'schoolKyc',
      })
    );
  }, []);

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'school-kyc-status',
            limit: 10,
            page: val,
            statuses: [status],
            latestFirst: true,
          },
          type: 'schoolKyc',
        })
      )
        .unwrap()
        .then((res) => {
          if (res && res.status > 299) {
            ErrorToast(res.message);
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
  };

  const handleStatus = (e) => {
    console.log({ e: e.target.value });
    setStatus(e.target.value);
    dispatch(storeSchoolKycApiStatus(e.target.value));
    if (schoolKycUserId !== '') {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'school-kyc-status',
            limit: 10,
            page: 1,
            statuses: [e.target.value],
            latestFirst: true,
            secondaryFilter: { userId: schoolKycUserId },
          },
          type: 'schoolKyc',
        })
      );
    } else {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'school-kyc-status',
            limit: 10,
            page: 1,
            statuses: [e.target.value],
            latestFirst: true,
          },
          type: 'schoolKyc',
        })
      );
    }
  };

  const handleSearchSchoolKyc = () => {
    console.log('search school kyc by user id', schoolKycUserId);
    if (schoolKycUserId !== '') {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'school-kyc-status',
            limit: 10,
            page: 1,
            statuses: [status],
            latestFirst: true,
            secondaryFilter: { userId: schoolKycUserId },
          },
          type: 'schoolKyc',
        })
      );
    } else {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'school-kyc-status',
            limit: 10,
            page: 1,
            statuses: [status],
            latestFirst: true,
          },
          type: 'schoolKyc',
        })
      );
    }
  };

  return (
    <Box py={4}>
      <Box
        borderBottom={`1px solid #dfdfdf`}
        pb={2}
        mb={4}
        fontSize={22}
        fontWeight={'fontWeightMedium'}>
        School KYC Approval
      </Box>
      <Box mb={3} display="flex">
        <Box mr={4} width={350}>
          <BuzzInput
            fullWidth={true}
            placeholder={'Search school KYC by user id'}
            search
            value={schoolKycUserId}
            onChange={(e) => setSchoolKycUserId(e.target.value)}
            onSubmitEditing={handleSearchSchoolKyc}
            size="small"
            label="Seach school KYC"
          />
        </Box>
        <Box>
          <BuzzSelect
            width={180}
            name="status"
            size={'small'}
            placeholder={'Select status'}
            value={status}
            onChange={handleStatus}
            label="Select status"
            valueKey="value"
            labelKey="label"
            options={STATUS_OPTION}
          />
        </Box>
      </Box>
      <BuzzTable columns={schoolKycListColumn} data={schoolKycList} />
      <Box display="flex" justifyContent="center">
        <BuzzPagination
          onClick={handlePageChange}
          total={schoolKycCount}
          pageNo={page}
          defaultPage={1}
          perPage={10}
        />
      </Box>
    </Box>
  );
}

export default SchoolKycApprove;
